export const env = {
    env: 'qa'

  };
